<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item>
          <el-button class="allRecord" v-if="showAllRecordBtn" type="primary"
            @click="goPaymentRecord">全部打款记录</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="printSelected">批量打印</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" :showSelect="true" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="isprint" slot-scope="params">
        <el-button class="printbtn" :type="params.params.isprint == 1 ? 'primary' : 'danger'"
          @click="printOne(params.params)" size="mini">
          {{ params.params.isprint == 1 ? '打印' : '已打印' }}
        </el-button>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceInitialPayment",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'car',
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
        { name: "打款记录" },
      ],
      formInline: {},
      formCtrl: [
        // {
        //   ...this.ctrls.fleet,
        //   label: '车队长',
        //   placeholder: '',
        //   options: [],
        // },
        // {
        //   ...this.ctrls.license
        // },
        {
          label: "打款时间",
          keyName: "month",
          type: "daterange",
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          placeholder: "打款金额",
          type: "number",
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "money", label: "预支款余额", align: 'right', className: 'pr30' },
        { keyName: "paymoney", label: "打款金额", align: 'right', className: 'pr30' },
        { keyName: "allmoney", label: "预支款现额", align: 'right', className: 'pr30' },
        { keyName: "isprint", label: "打印状态", slot: 'isprint' },
        { keyName: "repaytime", label: "打款时间" },
        { keyName: "username", label: "操作人", minwidth: 110 },
      ],
      getTotalProperty: ['paymoney'],
      btns: [
        {
          ...this.viewBtn,
          cb: (data) => {
            this.setData(data)
            this.viewMode = true
            this.title = '查看打款记录'
            this.$forceUpdate()
            this.showDialog()
          },
        },
        {
          ...this.editBtn,
          cb: (data) => {
            this.setData(data)
            this.viewMode = false
            this.title = '编辑打款记录'
            this.$forceUpdate()
            this.showDialog()
          },
        },
      ],
      title: '编辑打款记录',
      viewMode: false,
      mform: {
        paymoney: undefined,
        photo: undefined,
        // photo: [{ url: '' }],
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传打款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号",
          disabled: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款日期",
          keyName: "repaytime",
          err: "请填写打款日期",
          type: "text",
          disabled: true,
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "advance",
          max: 2,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      getListUrl: 'payrec',
      baseParams: ['id', 'license'],
      showAllRecordBtn: false,
    };
  },
  methods: {
    dataObjHandler(v) {
      return v
    },
    setData({ id, cid, license, driver, photos, paymoney, remark, repaytime }) {
      // console.log(id)
      this.mform = { ...this.mform, id, cid, license, driver, photo: photos, paymoney, remark, repaytime }
      this.$forceUpdate()
      console.log({ ...this.mform })
    },
    goPaymentRecord() {
      this.$router.push(
        `/finance/initialAllPaymentRecord`
      );
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      const { photo, paymoney, id, cid, remark } = this.mform
      if (!photo || !photo.length) {
        this.$message({
          type: 'warning',
          message: '请上传打款图片！'
        });
      }
      if (!paymoney) {
        this.$message({
          type: 'warning',
          message: '请填写打款金额！'
        });
      }
      let url = `car/updatemoney`
      const params = {
        cid,
        id,
        paymoney,
        remark,
      }
      params['photo'] = photo.map(v => {
        let result = v
        if (v.response && v.response.photo) {
          result = { url: v.response.photo }
        }
        return result
      })
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    setFleet({ team }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet') {
          c.options = [
            { label: '全部', value: '' },
          ]
          team.map(v => {
            c.options.push({
              label: v.nickname + '',
              value: v.id,
            })
          })
        }
      })
      this.$forceUpdate()
    },
    printSelected() {
      if (!this.selection.length) {
        this.$message({
          type: 'error',
          message: '请选择条目！'
        });
        return
      }
      console.log(this.selection)
      const arr = this.selection.map(v => v.id)
      let url = `car/allprint`
      const params = {
        delList: arr,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '打印成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    printOne({ id }) {
      // console.log(id)
      let url = `car/singleprint`
      const params = {
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '打印成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getFleet();
    this.setQueryParams();
    if (this.$route.query.id) {
      this.showAllRecordBtn = true
    }
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
/deep/ .fillet {
  .retrieval {
    .allRecord {
      width: 120px;
    }
  }
}

/deep/ .dialog {
  .el-dialog {
    .modal-scroll {
      // height: 350px;

      .el-scrollbar__wrap {
        overflow-x: hidden;

        .el-form {
          padding-right: 50px;
        }

        .btns {
          margin-left: 110px;
        }
      }

      .is-horizontal {
        display: none;
      }
    }
  }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}
</style>
